/* The Glow Up Guide — Blog (Journal) listing + article behaviour.
   Reveal-on-scroll, client-side topic filter, sticky mobile CTA.
   Theme-editor safe: re-binds on shopify:section:load, never leaves content hidden. */
(function () {
  function reveal(root) {
    var els = (root || document).querySelectorAll('.gugbl-reveal:not(.gugbl-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('gugbl-in'); });
      return;
    }
    // threshold 0: fire on ANY intersection. (A non-zero threshold is unreachable for elements
    // taller than viewport/threshold — e.g. a long article body on mobile would never reveal.)
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('gugbl-in'); obs.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    els.forEach(function (el) { io.observe(el); });
  }

  function topicFilter(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-gugbl-topics]').forEach(function (bar) {
      var grid = scope.querySelector('[data-gugbl-grid]');
      if (!grid) return;
      var chips = bar.querySelectorAll('.gugbl-chip');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var tag = (chip.getAttribute('data-tag') || '').toLowerCase();
          chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
          grid.querySelectorAll('[data-tags]').forEach(function (card) {
            var tags = (card.getAttribute('data-tags') || '').toLowerCase();
            var show = !tag || tag === 'all' || tags.split('|').indexOf(tag) !== -1;
            card.style.display = show ? '' : 'none';
          });
        });
      });
    });
  }

  function sticky(root) {
    var bar = (root || document).querySelector('.gugbl-sticky');
    if (!bar) return;
    var onScroll = function () {
      if (window.scrollY > 520) bar.classList.add('gugbl-show');
      else bar.classList.remove('gugbl-show');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function ytId(url) {
    if (!url) return '';
    var m = url.match(/(?:v=|\/embed\/|youtu\.be\/)([A-Za-z0-9_-]{11})/);
    return m ? m[1] : '';
  }

  // Click-to-load YouTube facade (lazy — iframe only loads on click, good for CWV).
  // Author drops <a class="gugbl-video" href="…youtube…">caption text</a> in the post body.
  function video(root) {
    (root || document).querySelectorAll('a.gugbl-video:not([data-gugbl-ready])').forEach(function (a) {
      var id = ytId(a.getAttribute('href'));
      if (!id) return; // leave it as a normal link if we can't parse an ID
      a.setAttribute('data-gugbl-ready', '1');
      var cap = (a.textContent || '').trim();

      var fig = document.createElement('figure');
      fig.className = 'gugbl-video';

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'gugbl-video-btn';
      btn.setAttribute('aria-label', cap ? ('Play video: ' + cap) : 'Play video');
      btn.style.backgroundImage = "url('https://i.ytimg.com/vi/" + id + "/hqdefault.jpg')";
      btn.innerHTML = '<span class="gugbl-video-play"><svg viewBox="0 0 68 48" aria-hidden="true">' +
        '<path d="M66.5 7.7c-.8-2.9-3-5.2-5.9-6C55.3.5 34 .5 34 .5S12.7.5 7.4 1.7c-2.9.8-5.1 3.1-5.9 6C.3 13 .3 24 .3 24s0 11 1.2 16.3c.8 2.9 3 5.2 5.9 6C12.7 47.5 34 47.5 34 47.5s21.3 0 26.6-1.2c2.9-.8 5.1-3.1 5.9-6C67.7 35 67.7 24 67.7 24s0-11-1.2-16.3z" fill="#E0457B"/>' +
        '<path d="M27 34l18-10L27 14z" fill="#fff"/></svg></span>';
      btn.addEventListener('click', function () {
        var frame = document.createElement('div');
        frame.className = 'gugbl-video-frame';
        var f = document.createElement('iframe');
        f.src = 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
        f.setAttribute('title', cap || 'Video');
        f.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        f.setAttribute('allowfullscreen', '');
        f.setAttribute('loading', 'lazy');
        frame.appendChild(f);
        btn.replaceWith(frame);
      });
      fig.appendChild(btn);

      if (cap) {
        var c = document.createElement('figcaption');
        c.className = 'gugbl-video-cap';
        c.textContent = cap;
        fig.appendChild(c);
      }

      // Replace the wrapping <p> if the link is its only content (avoids <figure> inside <p>).
      var target = a;
      var p = a.parentNode;
      if (p && p.tagName === 'P' && p.children.length === 1 && (p.textContent || '').trim() === cap) target = p;
      target.replaceWith(fig);
    });
  }

  // Responsive comparison tables: keep the pasted markup a CLEAN table (cells hold only data, so
  // search engines / AI extract it correctly) and add the per-cell mobile labels here at runtime,
  // copied from the <thead>. CSS shows them via td[data-label]::before on small screens.
  function stackTables(root) {
    (root || document).querySelectorAll('table.gugbl-table--stack:not([data-gugbl-labeled])').forEach(function (t) {
      var heads = [].map.call(t.querySelectorAll('thead th'), function (th) { return th.textContent.trim(); });
      if (heads.length < 2) return;
      t.setAttribute('data-gugbl-labeled', '1');
      [].forEach.call(t.querySelectorAll('tbody tr'), function (tr) {
        [].forEach.call(tr.children, function (td, i) {
          if (i > 0 && heads[i]) td.setAttribute('data-label', heads[i]);
        });
      });
    });
  }

  function init(root) { reveal(root); topicFilter(root); sticky(root); video(root); stackTables(root); }

  if (document.readyState !== 'loading') init(document);
  else document.addEventListener('DOMContentLoaded', function () { init(document); });

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
